import React, { FC } from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { useStyles } from '@wix/tpa-settings/react';
import { LoyaltyProgram } from '@wix/ambassador-loyalty-v1-program/types';
import { Status, TiersProgramSettings } from '@wix/ambassador-loyalty-v1-tier/types';

import { EmptyState } from './EmptyState';
import { ErrorState } from './ErrorState';
import { MainProgram } from './MainProgram';
import { TiersProgram } from './TiersProgram';
import { SimpleReward, SimpleRule, SimpleTier } from '../../../types/domain';
import { TabState } from '../../../types/settings';
import { DataHook } from '../../../types/data-hook';

export type ControllerProps = {
  hasError: boolean;
  tabState: TabState;
  loyaltyProgram: LoyaltyProgram;
  isLoggedIn: boolean;
  hasMyRewardsPage: boolean;
  onNavigateToMyRewardsPage(): void;
  simpleRules: SimpleRule[];
  simpleRewards: SimpleReward[];
  tiersProgramSettings: TiersProgramSettings;
  simpleTiers: SimpleTier[];
  isProgramAvailable: boolean;
};

const Widget: FC<WidgetProps<ControllerProps>> = ({
  hasError,
  tabState,
  loyaltyProgram,
  isLoggedIn,
  onNavigateToMyRewardsPage,
  hasMyRewardsPage,
  simpleRules,
  simpleRewards,
  tiersProgramSettings,
  simpleTiers,
  isProgramAvailable,
}) => {
  const styles = useStyles();
  if (hasError) {
    return <ErrorState />;
  }

  if (!isProgramAvailable) {
    return <EmptyState />;
  }

  const showTiers =
    styles.getStylesForAllBreakpoints().some((breakpointStyles) => breakpointStyles.booleans.showTiers) &&
    tiersProgramSettings?.status === Status.ACTIVE;

  return (
    <div data-hook={DataHook.LoyaltyWidget}>
      <MainProgram
        {...{
          tabState,
          loyaltyProgram,
          isLoggedIn,
          onNavigateToMyRewardsPage,
          hasMyRewardsPage,
          simpleRules,
          simpleRewards,
          showTiers,
        }}
      />
      {showTiers && <TiersProgram {...{ simpleTiers, simpleRules, simpleRewards, tiersProgramSettings }} />}
    </div>
  );
};

export default Widget;
